import { useState } from "react";
import { Button } from "@react-md/button";

import {
  EMAIL_PATTERN,
  PHONE_PATTERN,
  Select,
  TextArea,
  TextInput,
  useField,
} from "../../shared/form";
import api from "../../../shared/api";
import styles from "./index.module.scss";
import variables from "../../../styles/variables.module.scss";
import { planCards } from "../../../shared/helpers/constants";
import { useT } from "../../../i18n";

const Order = ({
  selected,
  setSelected,
}: {
  selected: string;
  setSelected: Function;
}) => {
  const t = useT();
  const [messageType, setMessageType] = useState<"success" | "error" | null>(
    null,
  );
  const [sending, setSending] = useState(false);

  const name = useField({ required: true, maxLength: 10 });
  const email = useField({ required: true, pattern: EMAIL_PATTERN });
  const phone = useField({ required: true, pattern: PHONE_PATTERN });
  const message = useField({ required: true, minLength: 4 });
  const fields = [name, email, phone, message];

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    fields.forEach((f) => f.touch());
    if (fields.some((f) => f.invalid) || sending) return;
    setSending(true);
    try {
      await api.post(`/support`, {
        email: email.value.trim(),
        message: message.value,
        name: `${selected} ${name.value.trim()}`,
        phoneNumber: phone.value.trim(),
      });
      setMessageType("success");
      setTimeout(() => {
        setSelected("");
        sessionStorage.removeItem("package");
      }, 2000);
    } catch (err) {
      setMessageType("error");
    } finally {
      setSending(false);
    }
    setTimeout(() => {
      setMessageType(null);
    }, 5000);
  };

  return (
    <form
      className={`${variables.row} ${styles.container} `}
      onSubmit={submit}
      noValidate
    >
      <span className={variables.title}>{t("order.title")}</span>
      {messageType && (
        <span
          className={variables.textSm}
          style={{ color: messageType === "success" ? "green" : "red" }}
        >
          {messageType === "success"
            ? t("support.success")
            : t("common.somethingWrong")}
        </span>
      )}
      <Select
        id="order-package"
        name="select"
        label={t("order.package")}
        value={selected}
        onChange={(event) => setSelected(event.currentTarget.value)}
      >
        <option value="" disabled hidden />
        {planCards.map(({ title }) => (
          <option key={title} value={title}>
            {t("order.packageOption", { title })}
          </option>
        ))}
      </Select>
      <TextInput
        id="order-name"
        autoComplete="name"
        label={t("order.name")}
        error={name.error}
        {...name.props}
      />
      <TextInput
        id="order-email"
        type="email"
        autoComplete="email"
        label={t("support.email")}
        error={email.error}
        {...email.props}
      />
      <TextInput
        id="order-phone"
        type="tel"
        autoComplete="tel"
        label={t("order.phone")}
        placeholder="+374 00-000-000"
        error={phone.error}
        {...phone.props}
      />
      <TextArea
        id="order-message"
        label={t("support.message")}
        error={message.error}
        {...message.props}
      />
      <Button
        type="submit"
        className={variables.containedBtn}
        themeType="contained"
        disabled={sending}
      >
        {sending ? t("common.sending") : t("common.send")}
      </Button>
    </form>
  );
};

export default Order;
